import React, { useState } from "react";
import { disableEmojiInput, getTranslations } from "../../../Common/utils";
import { InputField } from "../../InputField";
import { RadioButton } from "../../RadioButton";

const ReportLeague = ({ handleOnChange }) => {
  const radioValue = [
    {
      value: getTranslations(
        "manage_league_report_league_option_1",
        "Inappropriate language or content"
      ),
    },
    {
      value: getTranslations(
        "manage_league_report_league_option_2",
        "Harassment"
      ),
    },
    {
      value: getTranslations(
        "manage_league_report_league_option_3",
        "Racism/Sexism content"
      ),
    },
    {
      value: getTranslations(
        "manage_league_report_league_other_option_label",
        "Other"
      ),
    },
  ];

  const [selectedRadio, setSelectedRadio] = useState(null);
  const [otherText, setOtherText] = useState("");

  const handleOnChangeLocal = (e) => {
    const selectedValue = e.target.value;
    setSelectedRadio(selectedValue);
    
    // Check if "Other" is selected
    const isOtherSelected = selectedValue === radioValue[3].value;
    
    if (isOtherSelected) {
      // If "Other" is selected, use the otherText if it exists, otherwise empty string
      handleOnChange({
        id: 4,
        text: otherText.trim() || "",
      });
    } else {
      // For other radio options
      handleOnChange({
        id: radioValue.findIndex((x) => x.value === selectedValue) + 1,
        text: selectedValue,
      });
      // Clear other text when a different option is selected
      setOtherText("");
    }
  };

  const handleTextInput = (e) => {
    let val = disableEmojiInput(e.target.value);
    setOtherText(val);
    // Only update if "Other" is selected
    if (selectedRadio === radioValue[3].value) {
      handleOnChange({
        id: 4,
        text: val.trim(),
      });
    }
  };

  const isOtherSelected = () => {
    return selectedRadio === radioValue[3].value;
  };

  return (
      <form className="" action="" method="" role="" aria-label="">
        <div className="si-league__report-radio">
          <ul>
            {radioValue.map((item, index) => (
              <li key={index}>
                <RadioButton
                  radioName="leagueReport"
                  radioText={item.value}
                  radioId={index}
                  checked={item?.value === selectedRadio}
                  handleOnChange={(e) => handleOnChangeLocal(e)}
                />
              </li>
            ))}
          </ul>
          {isOtherSelected() && (
            <div className="si-league__report-field">
              <InputField
                inputID="customReport"
                inputType="text"
                ariaLable="Please enter your report"
                placeholderLabel={getTranslations(
                  "manage_league_report_league_other_option_placeholder",
                  "Please specify"
                )}
                isDisabled={false}
                inputText={otherText}
                handleInput={(e) => handleTextInput(e)}
              />
            </div>
          )}
        </div>
      </form>
  );
};

export default ReportLeague;
